import React, { useEffect, useState } from 'react'
// import { PaymentServices } from './BookingPaymentServices'
import { useForm, FormProvider, Controller, set } from 'react-hook-form';
import { Button, Card, Grid, IconButton, Modal, Paper, TextField, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
// import { PermissionGuard } from '../../../components/PermissionGuard';
// import { formatDateTime } from '../../../utils/dateUtils';
// import Loading from '../../../components/Loader/Loading';
import { Box, Stack } from '@mui/system';
// import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import { BorderColorOutlined, Cancel, CheckCircle, Close, Edit, EditOutlined, InfoOutlined, RestartAlt, Search } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
// import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import Swal from 'sweetalert2';
import AddEditPayment from '../../Payment/Booking/AddEditPayment';
import { formatDateTime } from '../../../utils/dateUtils';
import { PermissionGuard } from '../../../components/PermissionGuard';
import { PaymentServices } from '../../Payment/Booking/BookingPaymentServices';
import Loading from '../../../components/Loader/Loading';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import noImage from '../../../assets/images/no_image_available.png'
import { Helpers } from '../../../services/Helpers';

const PaymentRecordsList = ({fetchList,paymentRecords,loading}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  
  // State management
  const [allRowCount, setAllRowCount] = useState(0);
  const [list, setList] = useState([]);
  useEffect(()=>{
    setAllRowCount(paymentRecords.length);
    setList(paymentRecords);
  },[paymentRecords]);
  const columns = [
    {
      field: 'bookingId',
      headerName: 'Booking Id',
      flex: .5,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>{params.value|| 'N/A'}</Typography>
        </Box>
      ),
    },
    {
      field: 'bookingBalanceAmount',
      headerName: 'Booking Balance Amount',
      flex: 1,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>₹{params.value|| '0.00'}</Typography>
        </Box>
      ),
    },
    {
      field: 'customerPaidAmount',
      headerName: 'Customer Paid',
      flex: 1,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>₹{params.value|| '0.00'}</Typography>
        </Box>
      ),
    },
    {
      field: 'amountReceived',
      headerName: 'Cudel Received Amount',
      flex: 1,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>₹{params.value|| '0.00'}</Typography>
        </Box>
      ),
    },
    {
      field: 'paidBalanceAmount',
      headerName: 'Paid Balance Amount',
      flex: 1,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography  sx={{ fontSize: '0.65rem' }}>₹{params.value|| '0.00'}</Typography>
        </Box>
      ),
    },
    {
      field: `other Detail's`,
      headerName: `other Detail's`,
      flex: 1.75,
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => (


        <Box sx={{ p: 1, width: '100%' }}>
          <Box sx={{display:'flex',gap:1}}>
            <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>Tip/Adjustment</Typography>
            <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
            <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.tipAdjustmentType}</Typography>
          </Box>
          <Box sx={{display:'flex',gap:1}}>
            <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>payment Method</Typography>
            <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
            <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.paymentMethod}</Typography>
          </Box>
          <Box sx={{display:'flex',gap:1}}>
            <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>Expert Pmt.</Typography>
            <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
            <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.expertPaymentStatus}</Typography>
          </Box>
          <Box sx={{display:'flex',gap:1}}>
            <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>Payout Eligibility</Typography>
            <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
            <IconButton size='small' sx={{ p: 0 }}>          
              {
                params.row.isPayoutEligible ?
                  <CheckCircle color='success' sx={{ fontSize: '0.65rem' }} />
                  : <Cancel color='error' sx={{ fontSize: '0.65rem' }} />
              }
            </IconButton>
          </Box>
          {params.row?.paymentRemarks &&
            <Box sx={{display:'flex',gap:1}}>
              <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>Comment</Typography>
              <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
              <Typography  sx={{ fontSize: '0.65rem', }}>
                <Tooltip
                  componentsProps={{
                      tooltip: {
                          sx: {
                              padding: '0',
                              bgcolor: 'transparent'  // if you also want to remove background
                          }
                      }
                  }}
                  title={
                      <Paper sx={{ p: 1 ,width:'max-content',bgcolor:'#dde4ea'}}>
                          <Box sx={{ display: 'flex', alignItems: 'baseline',pb:0.5,mb:0.5 }}>
                              {/* <Typography fontWeight={'600'} sx={{ width: '30%', color: '#3E3E3E', fontSize: '0.75rem' }}>On Behalf</Typography>
                              <Typography fontWeight={'600'} sx={{ mr: '1%' }}>:</Typography> */}
                              <Typography fontWeight={'400'} sx={{ fontSize: '0.75rem', width: '100%', color: '#181818' }}>{params.row?.paymentRemarks}</Typography>
                          </Box>
                      </Paper>
                  }
              placement="bottom-start"  // You can change this to any valid placement
              PopperProps={{
                  modifiers: [
                  {
                      name: 'offset',
                      options: {
                      offset: [0, -10], // Horizontal and vertical offset
                      },
                  },
                  ],
              }}
              enterDelay={200}
              leaveDelay={200}
              >
                  {/* <InfoOutlined color="primary" sx={{ fontSize: '1rem', cursor: 'pointer', ml: 0.5,p:0 }} /> */}
                  <Typography variant="body2" color="primary" sx={{ fontSize: '0.65rem', cursor: 'pointer', ml: 0.5,p:0 }}>View Comment</Typography>
              </Tooltip>
              </Typography>
            </Box>
          }
        </Box>
      ),
    },
    {
      field: 'image',
      headerName: 'Image',
      headerAlign: 'center',
      flex: .5,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'center', width: '100%' }}>
          <Box>
            {params.row.image ? (
              // <img
              //   //   src={params.row.images} 
              //   src={`${Helpers.ImagePathUrl()}/booking-payment/sm/${params.row.image}`}
              //   alt={params.row.title}
              //   style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
              // />
              <Button size='small' variant="contained" color="primary" sx={{ fontSize: '0.6rem' }} onClick={() => window.open(`${Helpers.ImagePathUrl()}/booking-payment/${params.row.image}`,'_blank')}>View </Button>
            ) : (
              // <Skeleton variant="rectangular" width={35} height={35} animation={false} />
              <img
                //   src={params.row.images} 
                src={noImage}
                alt={params.row.title+'image_not_available'}
                style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
              />
            )}
          </Box>
        </Box>
      ),
    },
    {
      field: 'createdAt', headerName: 'Created At', headerAlign: 'center', flex: 0.75, filterable: false, sortingOrder: ['asc', 'desc'],
      valueGetter: (params) => {
        return formatDateTime(params.row.createdAt);
      },
      renderCell: (params) => (
        <Typography variant="body2" sx={{ width: '100%', textAlign: 'center', color: '#3e3e3e', fontSize: '0.6rem' }}>{formatDateTime(params.row.createdAt)}</Typography>
      ),
    },
    {
      field: 'updatedAt', headerName: 'Updated At', headerAlign: 'center', flex: 0.75, filterable: false, sortingOrder: ['asc', 'desc'],
      valueGetter: (params) => {
        return formatDateTime(params.row.updatedAt, 'date');
      },
      renderCell: (params) => (
        <Typography variant="body2" sx={{ width: '100%', textAlign: 'center', color: '#3e3e3e', fontSize: '0.6rem' }}>{params.row.updatedAt ? formatDateTime(params.row.updatedAt) : ''}</Typography>
      ),
    },
    {
      field: "actions", headerName: "Action", sortable: false, filterable: false, flex: .5, renderCell: (params) => {

        return (
          <Box sx={{width:"100%",textAlign:'center'}}>
            <PermissionGuard feature='booking-payment-record' permission='canEdit'>
              <IconButton color='warning' size='small' variant='outlined' onClick={() => handleEdit(params.row)} ><BorderColorOutlined sx={{fontSize:"1rem"}}/></IconButton>
            </PermissionGuard>
          </Box>
        );
      },
      headerAlign: 'center',
    },
  ];
  

    const [isEdit,setIsEdit] = useState(false);
    const [selectedPaymentRecord,setSelectedPaymentRecord] = useState(null);
    const handleModalClose = ()=>{
      setIsEdit(false);
      setSelectedPaymentRecord(null);
      fetchList();
    }
    const handleEdit = (record)=>{
        console.log("selected booking record:",record)
      setSelectedPaymentRecord({
        id: record.id,
        bookingId : record.bookingId,
        bookingNumber:record.booking.bookingNumber,
        bookingAmount:record.booking.total,
        bookingBalanceAmount : record.bookingBalanceAmount,
        customerPaidAmount : record.customerPaidAmount,
        image : record.image,
        paymentMethod : record.paymentMethod,
        expertPaymentStatus : record.expertPaymentStatus,
        amountReceived : record.amountReceived,
        isPayoutEligible : record.isPayoutEligible,
        referenceNumber : record.referenceNumber,
        customerFeedback : record.customerFeedback,
        paidBalanceAmount : record.paidBalanceAmount,
        tipAdjustmentType : record.tipAdjustmentType,
        paymentRemarks : record.paymentRemarks,
      });
      setIsEdit(true);
    }
  return (
    <>
      {loading && <Loading />}
      <Card sx={{ overflow: "auto" }}>
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff" }}>
          
          <DataGrid
            rows={list}
            columns={columns.map((col) => ({
              ...col,
              // flex: isSmallScreen && (col.flex || 1), // Ensure columns resize dynamically
              minWidth: isSmallScreen && (col.minWidth || 180), // Set a minimum width to avoid overlap
            }))}
            rowCount={allRowCount}
            pageSizeOptions={[5, 10, 20, 50, 100]}            
            disableMultiSort={true}
            loading={loading}
            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
              // toolbar: GridToolbar,   
              loadingOverlay: Loading,
              noRowsOverlay: ()=>(<NoRowsLayout message={"No Record Found"}/>),
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{
              lineHeight: 1,
              borderTopLeftRadius:0,
              borderLeft:0,
              '& .MuiDataGrid-cell': {
                // first cell borderLeft:0
                
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
              },
              '& .MuiDataGrid-columnHeaders': {
                borderBottom: '2px solid rgba(224, 224, 224, 1)',
                // borderTop: '2px solid rgba(224, 224, 224, 1)',
                fontWeight: 600,
                fontSize: '0.75rem',
                p: 0,
                // height: 'fit-content',
                minHeight: '0 !important',
                height: '2rem'
              },
              '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
              },
              '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                  borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnSeparator': {
                display: 'none',
              },
            }}
          />
        </Box>
      </Card>
      {/* ========== Payment Entry Details Modal =========== */}
      <Modal
        open={isEdit}
        // onClose={() => setOpenServiceDropdown(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50%', sm: '50%' },
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 0,
            width: { xs: "95%"},
            minHeight: '25%',
            maxHeight: '90%'
          }}

          borderRadius={2}
        >
          <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
              New Payment Entry
            </Typography>
            <IconButton
              size='small'
              onClick={handleModalClose}
              sx={{ p: 0 }}
              color='error'
            >
              <Close sx={{fontSize:{xs:'1rem',sm:'1.25rem'}}}/>
            </IconButton>
          </Box>
          {/* <PaymentDescription/> */}
          <AddEditPayment paymentRecordData={selectedPaymentRecord} isEdit={isEdit} closePaymentEntryDialog={handleModalClose}/>
        </Box>
      </Modal>
    </>
  )
}

export default PaymentRecordsList
